import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// トスアップ詳細（履歴）取得
export async function getOldTossUp(id: string, contract_version: number) {
  try {
    const path = "oldTossUp";
    const params = { id, contract_version };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const detail_data: {
      [key: string]: number | string | { [key: string]: string | string[] };
    } = response.data.detail_data[0];
    return { detail_data };
  } catch (error) {
    // logout();
    return { detail_data: {} };
  }
}
